import React, { useReducer } from "react";

const PaymentFormContext = React.createContext();

const initialState = {
  formStages: {
    amount: "expanded", // untouched, expanded, complete
    auth: "untouched", // untouched, requestCode, verifyCode, skipped, isFullyLoggedIn
    paymentInfo: "untouched", // untouched, chooseAddMethodType, addCard, methodSelected
  },
  hasAmountURLParam: false,
  amountErrorMsg: null,
  isSubmitting: false,
  // addOnAmounts: [],
  initialPaymentType: "",
};

const reducer = (state, action) => {
  switch (action.type) {
    case "setFormStages": {
      return {
        ...state,
        formStages: {
          ...state.formStages,
          ...action.payload,
        },
      };
    }

    case "setFormStage": {
      return {
        ...state,
        formStages: {
          ...state.formStages,
          [action.stage]: action.value,
        },
      };
    }

    case "skipIntroScreen": {
      return {
        ...state,
        formStages: {
          ...state.formStages,
          intro: "complete",
        },
      };
    }

    case "setHasAmountURLParam": {
      return {
        ...state,
        hasAmountURLParam: action.payload,
      };
    }

    case "setAmountErrorMsg": {
      return {
        ...state,
        amountErrorMsg: action.payload,
      };
    }

    case "setIsSubmitting": {
      return {
        ...state,
        isSubmitting: action.payload,
      };
    }

    case "setInitialPaymentType": {
      return { ...state, initialPaymentType: action.payload };
    }

    // case "setAddOnAmount": {
    //   let newAddOnAmounts = [...(state.addOnAmounts || [])];
    //   const foundIndex = newAddOnAmounts.findIndex(
    //     (a) => a.addOnID === action.payload.addOnID
    //   );
    //   if (foundIndex >= 0) newAddOnAmounts[foundIndex] = action.payload;
    //   else newAddOnAmounts.push(action.payload);
    //   return {
    //     ...state,
    //     addOnAmounts: newAddOnAmounts,
    //   };
    // }

    // case "removeAddOnAmount": {
    //   let newAddOnAmounts = [...state.addOnAmounts];
    //   const foundIndex = newAddOnAmounts.findIndex(
    //     (a) => a.addOnID === action.payload
    //   );
    //   if (foundIndex >= 0) newAddOnAmounts.splice(foundIndex, 1);
    //   return {
    //     ...state,
    //     addOnAmounts: newAddOnAmounts,
    //   };
    // }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};

function PaymentFormProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <PaymentFormContext.Provider value={{ state, dispatch }}>
      {children}
    </PaymentFormContext.Provider>
  );
}

function usePaymentForm() {
  const context = React.useContext(PaymentFormContext);
  if (context === undefined) {
    throw new Error(`usePaymentForm must be used within a PaymentFormProvider`);
  }
  return context;
}

export { PaymentFormContext, PaymentFormProvider, usePaymentForm };
